import { render, staticRenderFns } from "./CategoryCreateUpdate.vue?vue&type=template&id=0741743e"
import script from "./CategoryCreateUpdate.vue?vue&type=script&lang=js"
export * from "./CategoryCreateUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports